import React, { LegacyRef } from 'react';
import { createRoot, Root } from 'react-dom/client';
import moment from 'moment';
import { ThemeProvider } from '@workboard/wobo-ui';
import { Relationships } from '@workboard/action-item';
import { QueryProvider } from '@workboard/project-management';
import { withTranslation } from 'react-i18next';
import './sidePanel.scss';
import { updateTopMenuObjectName } from '../../../navbar/actions/top_menu.actions';
import { type WithTranslation } from '../../types/common.types';
import { SidePanelType, SidePanelState } from '../../types/sidePanel.types';
import { WbEventHandlerMixins, WbMarkdownHtml } from '../../../utils/common';
import AddITemModal from '../../../components/modals/addItemModal';
import ImgIconComp from '../../../components/imgcomp';
import OwnerListComp from './components/ownerList';
import AiLoopComp from './components/aiLoop';
import AiCommentsComp from './components/aiComments';
import AiSubActionsComp from './components/aiSubactions';
import AiAttachmentsComp from './components/aiAttachments';
import AiTagsComp from './components/aiTags';
import AiNotesComp from './components/aiNotes';
import AiRecentActivityComp from './components/aiRecentActivity';
import * as SidePanelAction from '../../actions/sidePanel.actions';
import * as CardAction from '../../actions/card.actionTypes';
import { updateRelationshipCounts } from '../../actions/card.actions';
import BoardService from '../../services/board.service';
import { getActivityTypeName, getAiTypeActionLabel, updateWsGraphData } from '../../utils';
import TabHamburgMenu from './components/tabMenu';
import { ToastNotificationProvider } from '../../../apps/project-management/notifications';
import { getFeatureFlag } from '../../../apps/project-management/utils/getFeatureFlag';
import { GlobalConfigProvider } from '../../../apps/project-management/global/ConfigProvider';
import { editorConfiguration } from './components/editorConfiguration';
import { WoboFileUploadService } from '../../../services/fileupload.service';
import { ActivityIssueTypes } from '../../types/ai.types';
import { InLineStateList } from './components/inLineStateList';
import { todayInProfileTimezone } from '../../utils/currentDate';

class SidePanel extends React.Component<WithTranslation<SidePanelType>, SidePanelState> {
    datepicker: JQuery<any>;
    datepickerTimer: NodeJS.Timeout | null;
    popupelement: any;
    showListRef: LegacyRef<HTMLDivElement>;
    boardSevice: any;
    constructor(props: WithTranslation<SidePanelType>) {
        super(props);
        const { t } = this.props;
        this.state = {
            ai: this.props.board.boardDetails.viewAiPane,
            selectedTab: "notes",
            aiAttachments: null,
            aiLoopMembers: null,
            aiSubActions: null,
            aiTags: null,
            aiRecentAct: null,
            aiNote: this.props.board.boardDetails.viewAiPane.note,
            updatedAiNotes: this.props.board.boardDetails.viewAiPane.note,
            currCmt: "",
            s3Data: null,
            upload_max_size: null,
            upload_max_size_configured: null,
            showAiDescEdit: false,
            initalMinDate: null,
            loadComments: null,
            showListPopup: "",
            aiAssigniList: [],
            isNoAttachmentDownload: false,
            tagId: this.props.board.boardDetails.tagId
        }
        this.tabClick = this.tabClick.bind(this);
        this.updateLoop = this.updateLoop.bind(this);
        this.startDateClick = this.startDateClick.bind(this);
        this.dueDateClick = this.dueDateClick.bind(this);
        this.initDatePicker = this.initDatePicker.bind(this);
        this.initializeDueDate = this.initializeDueDate.bind(this);
        this.initializeStartDate = this.initializeStartDate.bind(this);
        this.updateViewAiPaneAttrCount = this.updateViewAiPaneAttrCount.bind(this);
        this.fireDetEvent = this.fireDetEvent.bind(this);
        this.saveStartDate = this.saveStartDate.bind(this);
        this.saveEndDate = this.saveEndDate.bind(this);
        this.addTagToStateList = this.addTagToStateList.bind(this);
        this.addLoopToStateList = this.addLoopToStateList.bind(this);
        this.addAttachToStateList = this.addAttachToStateList.bind(this);
        this.removeItemFromList = this.removeItemFromList.bind(this);
        this.aiCountUpdate = this.aiCountUpdate.bind(this);
        this.showAiDescEditFn = this.showAiDescEditFn.bind(this);
        this.updateAiNote = this.updateAiNote.bind(this);
        this.saveAiNote = this.saveAiNote.bind(this);
        this.updCurrCmt = this.updCurrCmt.bind(this);
        this.addAiSubAction = this.addAiSubAction.bind(this);
        this.addComment = this.addComment.bind(this);
        this.editComment = this.editComment.bind(this);
        this.removeCommentFromList = this.removeCommentFromList.bind(this);
        this.onShowListPopup = this.onShowListPopup.bind(this);
        this.deleteAiClick = this.deleteAiClick.bind(this);
        this.registerPopup = this.registerPopup.bind(this);
        this.subAiClick = this.subAiClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.openAiDetailPopupMenu = this.openAiDetailPopupMenu.bind(this);
        this.openAiDetailPopup = this.openAiDetailPopup.bind(this);
        this.pingAi = this.pingAi.bind(this);
        this.hideShowListPopup = this.hideShowListPopup.bind(this);
        this.removeSubAi = this.removeSubAi.bind(this);
        this.subAiConvClick = this.subAiConvClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.subAIClosePopup = this.subAIClosePopup.bind(this);
        this.addSubAiItem = this.addSubAiItem.bind(this);
        this.onCloseAiPane = this.onCloseAiPane.bind(this);
        this.updateAttachState = this.updateAttachState.bind(this);
        this.popupelement = document.getElementById("rbr-add-popup-wrapper");
        this.boardSevice = new BoardService();
    }

    componentDidMount() {
        const { boardDetails } = this.props.board;
        const { ai } = this.state;
        this.updateViewAiPaneAttrCount();
        if (ai.full_access || ai.attr_access || ai.direct_parent_access) {
            this.initializeDueDate();
            this.initializeStartDate();
        }
        this.fireDetEvent(ai.id, boardDetails.tagId);

        $(window).on("resize", this.positionDatePicker);
    }

    componentWillUnmount() {
        $(window).off("resize", this.positionDatePicker);
    }

    static getDerivedStateFromProps(nextProps: SidePanelType, prevState: SidePanelState) {
        if (nextProps.board.boardDetails.viewAiPane !== prevState.ai) {
            return { ai: nextProps.board.boardDetails.viewAiPane };
        }
        else return null;
    }

    componentDidUpdate(prevProps: SidePanelType) {
        const { viewAiPane } = this.props.board.boardDetails;
        let resValue: string = "0";
        let elem: any = document.querySelector('#fromMainAIPopup');
        if (elem) {
            resValue = elem.value;
            elem.value = "0";
        }
        if (viewAiPane != prevProps.board.boardDetails.viewAiPane) {
            this.setState({
                ai: viewAiPane,
                aiNote: viewAiPane.note,
                updatedAiNotes: viewAiPane.note
            })
        }
        if (this.state.selectedTab == "attach") {
            resValue == "1" && this.tabClick("attach", true);
        } else if (this.state.selectedTab == "loop") {
            resValue == "1" && this.tabClick("loop", true);
        } else if (this.state.selectedTab == "subAi") {
            resValue == "1" && this.tabClick("subAi", true);
        } else if (this.state.selectedTab == "tags") {
            resValue == "1" && this.tabClick("tags", true);
        } else if (this.state.selectedTab == "comments") {
            resValue == "1" && this.tabClick("comments", true);
        }
    }

    tabClick = (selVal: string, fromPopup: boolean = false) => {
        const _this = this;
        const { boardDetails } = this.props.board;
        const { ai } = _this.state;
        const aiId = ai.id;
        const { teamId } = boardDetails;
        if (selVal == "attach") {
            if (this.state.aiAttachments != null && !fromPopup) {
                _this.setState({
                    selectedTab: selVal
                });
            } else {
                $.ajax({
                    url: `${wbConfig.baseUrl}/board/AiAttachments`,
                    type: "get",
                    data: { aiId, teamId }
                }).done(response => {
                    if (response.status == "success") {
                        const { attachments } = response;
                        _this.setState({
                            selectedTab: selVal,
                            aiAttachments: attachments,
                            s3Data: response.s3Data,
                            upload_max_size: response.upload_max_size,
                            upload_max_size_configured: response.upload_max_size_configured,
                            isNoAttachmentDownload: response.isNoAttachmentDownload
                        });
                    }
                });
            }
        } else if (selVal == "loop") {
            if (this.state.aiLoopMembers != null && !fromPopup) {
                _this.setState({
                    selectedTab: selVal
                });
            } else {
                $.ajax({
                    url: `${wbConfig.baseUrl}/board/getAiLoopMembers`,
                    type: "get",
                    data: { aiId }
                }).done(response => {
                    if (response.status == "success") {
                        const { loopMembers } = response;
                        const columnId = ai.columnId || ai.state;
                        let ownerData = loopMembers.find((d: any) => d.id == _this.state.ai.owner);
                        let loopCount = loopMembers.length || 0;
                        if (ownerData) {
                            _this.aiCountUpdate(ai.id, "loopCount", loopCount - 1, columnId);
                        }
                        let finalLoopMember = loopMembers.filter((d: any) => d.id != _this.state.ai.owner)
                        _this.setState({
                            selectedTab: selVal,
                            aiLoopMembers: finalLoopMember
                        });
                    }
                });
            }
        } else if (selVal == "subAi") {
            if (this.state.aiSubActions != null && !fromPopup) {
                _this.setState({
                    selectedTab: selVal
                });
            } else {
                $.ajax({
                    url: `${wbConfig.baseUrl}/board/getSubactions`,
                    type: "get",
                    data: { aiId }
                }).done(response => {
                    if (response.status == "success") {
                        const subActions = response.subTaskDetails;
                        _this.setState({
                            selectedTab: selVal,
                            aiSubActions: subActions
                        });
                    }
                });
            }
        } else if (selVal == "tags") {
            if (this.state.aiTags != null && !fromPopup) {
                _this.setState({
                    selectedTab: selVal
                });
            } else {
                $.ajax({
                    url: `${wbConfig.baseUrl}/board/getAiUserTag`,
                    type: "get",
                    data: { aiId }
                }).done(response => {
                    if (response.status == "success") {
                        const { userTags } = response;
                        _this.setState({
                            selectedTab: selVal,
                            aiTags: userTags
                        });
                    }
                });
            }
        } else if (selVal == "recentAct") {
            if (this.state.aiRecentAct != null) {
                _this.setState({
                    selectedTab: selVal
                });
            } else {
                $.ajax({
                    url: `${wbConfig.baseUrl}/board/getAiRecentActivity`,
                    type: "get",
                    data: { aiId }
                }).done(response => {
                    if (response.status == "success") {
                        _this.setState({
                            selectedTab: selVal,
                            aiRecentAct: response.recentActivity
                        });
                    }
                });
            }
        } else if (selVal == "notes") {
            _this.setState({
                selectedTab: selVal
            });
        } else if (selVal == "comments") {
            if (this.state.loadComments != null && !fromPopup) {
                _this.setState({
                    selectedTab: selVal
                });
            } else {
                $.ajax({
                    url: `${wbConfig.baseUrl}/board/AiComments`,
                    type: "get",
                    data: { aiId }
                }).done(response => {
                    if (response.status == "success") {
                        const aiCommentsVal = response.comments;
                        if (aiCommentsVal) {
                            _this.setState({
                                selectedTab: selVal,
                                loadComments: aiCommentsVal
                            });
                        }
                    }
                });
            }
        } else if (selVal == "relationships") {
            _this.setState({
                selectedTab: selVal
            });
        }
    }

    updateLoop = (data: any) => {
        const { ai } = this.state;
        const columnId = ai.columnId || ai.state;
        data = data.filter((d: any) => d.id != ai.owner)
        this.setState({
            aiLoopMembers: data
        }, () => {
            let loopCount = this.state.aiLoopMembers.length || 0;
            this.aiCountUpdate(ai.id, "loopCount", loopCount, columnId);
        });
    }

    startDateClick = (aiId: string) => {
        if (
            this.state.ai.full_access ||
            this.state.ai.attr_access ||
            this.state.ai.direct_parent_access
        ) {
            ($("#wsBoardAiStartText") as any).datepicker("show");
        }
    }

    dueDateClick = (aiId: string) => {
        if (
            this.state.ai.full_access ||
            this.state.ai.attr_access ||
            this.state.ai.direct_parent_access
        ) {
            ($("#wsBoardAiDueText") as any).datepicker("show");
        }
    }

    positionDatePicker = () => {
        // is the datepicker visible?
        if (($(this.datepicker) as any).datepicker("widget").is(":visible")) {
            clearTimeout(this.datepickerTimer);

            this.datepickerTimer = setTimeout(() => {
                // is the datepicker visible?
                if (($(this.datepicker) as any).datepicker("widget").is(":visible")) {
                    ($(this.datepicker) as any).datepicker("hide").datepicker("show");
                }
            }, 200);
        }
    }

    initDatePicker = (obj: any, callback: (arg0: JQuery<any>, arg1: any) => void) => {
        this.datepicker = $(obj);
        ($(this.datepicker) as any).datepicker({
            showAnim: '', // disable animation for fast widget resposition after window resize
            dateFormat: "M d,yy",
            onChangeMonthYear(year: any, month: any, inst: { input: any; }) {
                const buttonPane = ($(inst.input) as any).datepicker("widget");
                $(buttonPane)
                    .find("button.newStyleForDatePicker")
                    .remove();
                setTimeout(() => {
                    const btn = $(
                        '<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>'
                    );
                    btn.off("click").on("click", () => {
                        ($ as any).datepicker._clearDate(inst.input);
                    });
                    if ($(".wbmodal-datepicker .newStyleForDatePicker").length == 0) {
                        btn.appendTo(buttonPane);
                    }
                }, 1);
            },
            beforeShow(input: any, inst: { dpDiv: { css: (arg0: { marginLeft: string; }) => void; }; }) {
                $("#ui-datepicker-div").addClass(
                    "dataTimePicker wbmodal-datepicker datePickerLeft"
                );
                setTimeout(() => {
                    const buttonPane = ($(input) as any).datepicker("widget");
                    const btn = $(
                        '<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>'
                    );
                    btn.off("click").on("click", () => {
                        ($ as any).datepicker._clearDate(input);
                    });
                    if ($(".wbmodal-datepicker .newStyleForDatePicker").length == 0) {
                        btn.appendTo(buttonPane);
                        inst.dpDiv.css({
                            marginLeft: "-20px"
                        });
                    }
                }, 1);
            },
            onSelect(date: any) {
                callback($(this), date);
            }
        });

        ($(obj) as any)
            .datepicker()
            .datepicker("setDate", new Date());
    }

    initializeDueDate = () => {
        this.initDatePicker($("#wsBoardAiDueText"), this.saveEndDate);
    }

    initializeStartDate = () => {
        this.initDatePicker($("#wsBoardAiStartText"), this.saveStartDate);
    }

    updateViewAiPaneAttrCount = () => {
        const { actions } = this.props;
        const { ai } = this.state;
        showLoaderWidget($("#content"));
        $.ajax({
            url: `${wbConfig.baseUrl}/board/aiAttrCount`,
            type: "get",
            data: { aiId: ai.id }
        }).done(response => {
            removeLoader();
            if (response.status == "success") {
                const aiAttrCnt = response.countArr;
                if (aiAttrCnt) {
                    actions.WsBoardViewAiPaneAttrCountUpdate(
                        Object.assign({}, { id: ai.id }, aiAttrCnt)
                    );
                }
            }
        }).catch(() => {
            removeLoader();
        });
    }

    fireDetEvent = (aiId: any, tagId: any) => {
        $.get(`${wbConfig.baseUrl}/board/fireAiDetEvent`, { aiId, tagId });
    }

    saveStartDate = (obj: any, date: Date | string) => {
        const { ai, tagId } = this.state;
        const aiId = ai.id;
        const columnId = ai.columnId || ai.state;
        // check if start date is greater than end date
        const endDt = ai.dueDateTextFormatted;
        const dataStr: any = $(obj).val();
        const dateStartEnd =
            dataStr != "" && dataStr != "No Date" ? new Date(dataStr) : 0;
        const dateDueEnd = endDt != "" && endDt != "No Date" ? new Date(endDt) : 0;
        if (dateStartEnd != 0 && dateDueEnd != 0 && dateDueEnd < dateStartEnd) {
            (ai_date_start_popup as any).dialogOpen();
            return false;
        }
        let startTimeStamp = 0;
        if (date == "") {
            var updatedDStrYear = "No Date";
            date = "No Date";
            startTimeStamp = 0;
        } else {
            var updatedDStrYear = moment(date, "MMM DD, YYYY").format("MMM DD, YYYY");
            startTimeStamp = new Date(date).getTime() / 1000;
        }
        this.props.dispatch(SidePanelAction.boardAiStartDateChange(aiId, updatedDStrYear, date, startTimeStamp, columnId));
        $.post(
            `${wbConfig.baseUrl}/activity/UpdateStartDate`,
            { start_date: date, act_id: aiId },
            () => {
                updateWsGraphData(tagId);
            }
        );
    }

    saveEndDate = (obj: any, date: Date | string) => {
        const { ai, tagId } = this.state;
        const aiId = ai.id;
        const columnId = ai.columnId || ai.state;
        // check if end date is less than start date
        const stDt = ai.startDateTextFormatted;
        const dataStr: any = $(obj).val();
        const dateDueEnd =
            dataStr != "" && dataStr != "No Date" ? new Date(dataStr) : 0;
        const dateDueStart = stDt != "" && stDt != "No Date" ? new Date(stDt) : 0;
        if (dateDueStart != 0 && dateDueEnd != 0 && dateDueEnd < dateDueStart) {
            (ai_date_due_popup as any).dialogOpen();
            return false;
        }
        let overdue = "remove";
        let dueDateVal: any = 0;
        if (date == "") {
            var updatedDStrYear = "No Date";
            date = "No Date";
        } else {
            var updatedDStrYear = moment(date, "MMM DD, YYYY").format("MMM DD, YYYY");
            dueDateVal = new Date(date).getTime() / 1000;
            const now = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000;
            if (
                typeof dueDateVal !== "undefined" &&
                // dueDateVal != "" &&
                dueDateVal != 0 &&
                dueDateVal < now
            ) {
                overdue = "add";
            }
        }
        let dueRed = "";
        if (overdue == "add") {
            dueRed = "1d";
        }
        this.props.dispatch(SidePanelAction.boardAiEndDateChange(aiId, updatedDStrYear, date, dueRed, dueDateVal, columnId));
        $.post(
            `${wbConfig.baseUrl}/activity/UpdateDueDate`,
            { due_date: date, act_id: aiId },
            () => {
                updateWsGraphData(tagId);
            }
        );
    }

    addTagToStateList = (data: any) => {
        // console.log(this.props,"this.props");
        if (data) {
            const { ai, aiTags } = this.state;
            const columnId = ai.columnId || ai.state;
            const aiId: string = ai.id;
            aiTags.unshift(data);
            this.setState({ aiTags });
            let tagCount = parseInt(ai.tagCount) + 1;
            tagCount = tagCount <= 0 ? 0 : tagCount;
            this.props.dispatch(SidePanelAction.boardAddTag(aiId, data, columnId))
            this.aiCountUpdate(ai.id, "tagCount", tagCount, columnId);
        }
    }

    addLoopToStateList = (data: any) => {
        if (data) {
            const { ai, aiLoopMembers } = this.state;
            const columnId = ai.columnId || ai.state;
            aiLoopMembers.unshift(data);
            this.setState({ aiLoopMembers });
            let loopCount = parseInt(ai.loopCount) + 1;
            loopCount = loopCount <= 0 ? 0 : loopCount;
            this.aiCountUpdate(ai.id, "loopCount", loopCount, columnId);
        }
    }

    addAttachToStateList = (data: { id: any; }, s3Data: any) => {
        if (data && data.id) {
            const { ai, aiAttachments } = this.state;
            const columnId = ai.columnId || ai.state;
            aiAttachments.unshift(data);
            this.setState({
                aiAttachments,
                s3Data
            });
            let attachCount = parseInt(ai.attachCount) + 1;
            attachCount = attachCount <= 0 ? 0 : attachCount;
            this.aiCountUpdate(ai.id, "attachCount", attachCount, columnId);
        }
    }

    updateAttachState = (data: { id: any; fus_status: any; path: any }) => {
        if (data && data.id) {
            const _this = this;
            let { aiAttachments } = this.state;
            if (Array.isArray(aiAttachments)) {
                aiAttachments = aiAttachments.map((item) => {
                    if (item.file_id == data.id) {
                        item.fus_status = data.fus_status;
                        item.attach_link = data.path;
                    }
                    return item;
                });
                _this.setState({
                    aiAttachments
                });
            }
        }
    }

    removeItemFromList = (stateType: string, idVal: any, removeAccess: any) => {
        if (stateType && idVal && removeAccess) {
            const { ai } = this.state;
            const aiId = ai.id;
            const columnId = ai.columnId || ai.state;
            if (stateType == "aiTags") {
                let newTagCnt = parseInt(ai.tagCount) - 1;
                newTagCnt = newTagCnt <= 0 ? 0 : newTagCnt;
                let tags = this.state.aiTags;
                if (tags) {
                    tags = tags.filter((item: { id: any; }) => item.id != idVal);
                    this.setState({ aiTags: tags });
                    this.props.dispatch(SidePanelAction.boardRemoveTag(aiId, idVal, columnId));
                }
                this.aiCountUpdate(aiId, "tagCount", newTagCnt, columnId);

                $.post(
                    `${wbConfig.baseUrl}/activity/removeTagFromAi`,
                    { act_id: aiId, tag_id: idVal },
                    (data, status) => { }
                );
            } else if (stateType == "aiLoopMembers") {
                $.post(
                    `${wbConfig.baseUrl}/activity/handleLoopMember`,
                    { actId: aiId, memId: idVal, actType: "remove" },
                    (data, status) => { }
                );
                let newLoopCnt = parseInt(ai.loopCount) - 1;
                newLoopCnt = newLoopCnt <= 0 ? 0 : newLoopCnt;
                this.aiCountUpdate(aiId, "loopCount", newLoopCnt, columnId);
                let { aiLoopMembers } = this.state;
                if (aiLoopMembers) {
                    aiLoopMembers = aiLoopMembers.filter((item: { id: any; }) => item.id != idVal);
                    this.setState({ aiLoopMembers });
                }
            } else if (stateType == "aiAttachments") {
                const { t } = this.props;
                if (window.confirm(t('Delete attachment?'))) {
                    let newAttCnt = parseInt(ai.attachCount) - 1;
                    newAttCnt = newAttCnt <= 0 ? 0 : newAttCnt;
                    this.aiCountUpdate(aiId, "attachCount", newAttCnt, columnId);
                    let { aiAttachments } = this.state;
                    let deletedAttachment = null;
                    if (aiAttachments) {
                        aiAttachments = aiAttachments.filter((item: { id: any; }) => {
                            if (item.id == idVal) {
                                deletedAttachment = item;
                            }
                            return item.id != idVal;
                        });
                        this.setState({ aiAttachments });
                    }
                    $.post(
                        `${wbConfig.baseUrl}/attachment/delete?id=${idVal}`,
                        { act_id: aiId },
                        (data, status) => { }
                    );

                    if (deletedAttachment && deletedAttachment.fus_type == 1 && deletedAttachment.fileSignature) {
                        WoboFileUploadService.delete(deletedAttachment.fileSignature);
                    }
                }
            }
        }
    }

    aiCountUpdate = (aiId: any, countType: any, count: any, columnId?: string, subCountData?: any) => {
        this.props.dispatch(SidePanelAction.updateCount(aiId, countType, count, columnId, subCountData));
    }

    showAiDescEditFn = (e: { preventDefault: () => void; stopPropagation: () => void; }, value: any, descAccess: any) => {
        e.preventDefault();
        e.stopPropagation();
        if (!descAccess) {
            return;
        }
        const _this = this;
        const aiDesc = $.trim(($(_this.refs.wsBoardAiDescEditRef) as any).val());
        const { ai } = _this.state;
        const columnId = ai.columnId || ai.state;
        let updateDescription = $.trim(($(_this.refs.wsBoardAiDescEditRef) as any).val());
        let resUpdateDesc = updateDescription.replace("<", "&lt;");
        resUpdateDesc = resUpdateDesc.replace(">", "&gt;");
        if (!value && ai.description != aiDesc && aiDesc != "") {
            this.props.dispatch(SidePanelAction.boardChangeAIDesc(ai.id, resUpdateDesc, columnId));
            $.post(
                `${wbConfig.baseUrl}/activity/updateAiDescription`,
                { aiDescription: aiDesc, actId: ai.id },
                () => {
                    updateTopMenuObjectName(ai.id, "mywork", aiDesc);
                }
            );

            setTimeout(
                () =>
                    _this.setState({
                        showAiDescEdit: value
                    }),
                0
            );
        } else {
            _this.setState({
                showAiDescEdit: value
            });
            setTimeout(
                () => WbEventHandlerMixins.descAutoHeight("#wsBoardAiDescEdit"),
                10
            );
        }
    }

    updateAiNote = (value: any) => {
        this.setState({
            aiNote: value
        });
    }

    saveAiNote = (value: string) => {
        const updatedVal = value?.trim();
        const { ai } = this.state;

        const aiId = ai.id;
        const columnId = ai.columnId || ai.state;
        this.setState({ updatedAiNotes: updatedVal });
        // actions.WbBoardChangeAINotes({ id: aiId, notes: updatedVal });
        this.props.dispatch(SidePanelAction.boardChangeAINotes(aiId, updatedVal, columnId));
        $.post(
            `${wbConfig.baseUrl}/activity/saveAiNotes`,
            { actId: aiId, aiNote: updatedVal },
            (data, status) => { }
        );
    }

    updCurrCmt = (cmtVal: any) => {
        this.setState({
            currCmt: cmtVal
        });
    }

    addAiSubAction = (subActText: any) => {
        const { board } = this.props;
        const { boardDetails } = board;
        const { ai } = this.state;
        const _this = this;
        const randNum = Math.floor(Math.random() * 10000000) + 1;
        const tempAiId = `newAi_${randNum}`;
        if (subActText && subActText.trim() != '') {
            const { currentDate, user } = boardDetails;
            const boardId = boardDetails.tagId;
            const parentAiId = ai.id;
            const today = todayInProfileTimezone(currentDate);
            const dateVal = today.date;
            const stateText = WbEventHandlerMixins.getStateText(ai.state);
            const { board_column, columnId } = ai;
            let newSubAI: any = WbEventHandlerMixins.getTempAi(user, today.date_formatted, subActText, tempAiId, ai.state, "subAi");
            newSubAI.owner = user.id;
            newSubAI.parent = ai.id;
            this.props.dispatch({
                type: CardAction.ADD_AI_CARD,
                columnId,
                payload: { ...newSubAI },
            });
            this.setState((prevState: any) => ({
                aiSubActions: [...prevState.aiSubActions, newSubAI]
            }));
            $.post(
                `${wbConfig.baseUrl}/activity/quickAddSubmit`,
                {
                    wsBoardView: true,
                    quickAdd: subActText,
                    actionType: "editAi",
                    state: stateText,
                    dueDate: dateVal,
                    rag: "green",
                    priority: "low",
                    effort: "1",
                    parentActId: parentAiId,
                    boardId,
                    boardColumn: board_column
                },
                (data, status) => {
                    if (status == "success" && data && data != '') {
                        const subAi = data.data.sub_action;
                        const mainAi = data.data.main_ai;
                        this.setState((prevState: any) => {
                            const { aiSubActions: prevSubActions } = prevState;
                            const newSubAi = prevSubActions.find(subAction => subAction.id === tempAiId);
                            const prevSubactionsCopy = Object.assign([], prevSubActions);
                            prevSubactionsCopy[prevSubactionsCopy.indexOf(newSubAi)] = subAi;
                            return {
                                aiSubActions: prevSubactionsCopy
                            };
                        });
                        this.props.dispatch({
                            type: CardAction.UPDATE_AI_CARD,
                            columnId,
                            id: tempAiId,
                            payload: mainAi
                        });
                    }
                }
            );
        }
    }

    addComment = (commentVal: string, hiddenUserId: any, mentionedTeamId: any) => {
        const _this = this;
        if (commentVal == "") {
            return;
        }
        const { ai } = _this.state;
        const aiId = ai.id;
        type data = {
            data: never
        }
        // insert temp comment until response is received
        const commentUrl = `${wbConfig.baseUrl}/comment/create?aid=${aiId}`;
        const posting = $.post(
            commentUrl,
            {
                Comment: commentVal,
                act_id: aiId,
                wsBoardView: true,
                mentioned_user_id: hiddenUserId,
                mentioned_team_id: mentionedTeamId,
            },
            (data: data, status) => {
                if (status == "success") {
                    const comments = _this.state.loadComments;
                    // const respData = data.data;
                    comments.unshift(data.data);
                    _this.setState({ loadComments: comments });
                    let commentCount = parseFloat(ai.commentCount) + 1;
                    commentCount = commentCount <= 0 ? 0 : commentCount;
                    _this.aiCountUpdate(aiId, "commentCount", commentCount, ai.columnId);
                }
            }
        );
    }

    editComment = (cmtId: string | string[], ownerAccess: any, val: any) => {
        if (!ownerAccess) {
            return;
        }
        const n = cmtId.indexOf("newComm_");
        if (n > -1) {
            return;
        }
        const _this = this;
        const { ai } = _this.state;
        const aiId = ai.id;
        let comments = _this.state.loadComments;
        if (Array.isArray(comments)) {
            comments = comments.map((item) => {
                if (item.id == cmtId) {
                    item.comment = val;
                }
                return item;
            });
            _this.setState({ loadComments: comments });
        }
        $.post(
            `${wbConfig.baseUrl}/comment/CommentEdit?aid=${aiId}`,
            { comment: val, act_id: aiId, commentId: cmtId },
            () => { }
        );
    }

    removeCommentFromList = (cmtId: string | string[], ownerAccess: boolean) => {
        if (!ownerAccess) {
            return;
        }
        const n = cmtId.indexOf("newComm_");
        if (n > -1) {
            return;
        }
        const _this = this;
        const { ai } = _this.state;
        const aiId = ai.id;
        const columnId = ai.columnId || ai.state;
        let comments = _this.state.loadComments;
        if (Array.isArray(comments)) {
            comments = comments.filter((item) => item.id != cmtId);
            _this.setState({ loadComments: comments });
            let commentCount = parseFloat(ai.commentCount) - 1;
            commentCount = commentCount <= 0 ? 0 : commentCount;
            _this.aiCountUpdate(aiId, "commentCount", commentCount, columnId);
        }
        $.post(
            `${wbConfig.baseUrl}/comment/delete`,
            { act_id: aiId, cmt_id: cmtId, cmt_del: true },
            (data, status) => { }
        );
    }

    onShowListPopup = (view: any, access: any) => {
        if (view && access) {
            const { ai } = this.state;
            this.setState({
                showListPopup: view
            });
        }
    }

    copyAiLink = (item: { aiId: any; }) => {
        WBCopyToClipboard.actionItemUrl(item.aiId);
    };

    deleteAiClick = (item: any) => {
        const { t } = this.props;
        if (confirm(t('Delete the item?'))) {
            $(".wsBoardWrapper .wspopupmenu-wrapper").hide();

            showLoaderWidget($("#content"));
            $.post(
                `${wbConfig.baseUrl}/activity/Delete`,
                { act_id: item.id, ajax: true },
                () => {
                    removeLoader();
                    this.props.dispatch(SidePanelAction.boardAiDelete(item.id, item.columnId, item.parent, item.state));
                }
            );
        }
    }

    registerPopup = () => {
        if (!$(this.popupelement).hasClass("ui-dialog-content")) {
            ($(this.popupelement) as any).dialog({
                autoOpen: false,
                resizable: false,
                minHeight: 240,
                minWidth: 700,
                modal: true,
                open(event: any, ui: any) {
                    $(this.popupelement)
                        .siblings("div.ui-dialog-titlebar")
                        .remove();
                    $(this.popupelement)
                        .parents("div.ui-dialog")
                        .css("padding", "0");
                    $(this.popupelement).css({ "min-height": "135px" });
                    $(this.popupelement)
                        .parent()
                        .addClass("dialogbox-shadow");
                    const type = $(this.popupelement).data("type");
                    ($(this.popupelement) as any).dialog("option", "width", type == "ai" ? 700 : 700);
                }
            });
        }
    }

    private addPopupWrapperRoot: Root;

    subAiClick = (item: any) => {
        const _this = this;
        const { t } = this.props;
        const id = "ai";
        let items = [];
        const { ai } = this.state;
        const actId = ai.id;
        const tagId = ai.board;
        const { parent, type } = ai;
        this.registerPopup();
        const url = "activity/getMyRecentAIList";
        const actionLabel = getAiTypeActionLabel().toLowerCase();
        if (url) {
            showLoaderWidget($("#content"));
            $.get(`${wbConfig.baseUrl}/${url}`, { tagId, parent, actId }).then(
                resp => {
                    items = resp.ais || [];
                    removeLoader();
                    this.addPopupWrapperRoot = createRoot(document.getElementById("rbr-add-popup-wrapper"));
                    this.addPopupWrapperRoot.render(
                        <AddITemModal
                            id="ai"
                            name={t('Choose the {{actionLabel}} to add the subtask to', { actionLabel })}
                            placeholder={t('Search for an {{actionLabel}} by name or owner', { actionLabel })}
                            items={items}
                            closePopup={_this.subAIClosePopup}
                            addItem={_this.addSubAiItem}
                            actId={actId}
                            tagId={tagId}
                            parent={parent}
                            forSubAI={true}
                            item={item}
                        />
                    );
                }
            );
        } else {
            this.closePopup();
        }
    }

    closePopup = () => {
        if (this.popupelement != "") {
            ($(this.popupelement) as any).dialog("close");
        }
    }

    subAIClosePopup = () => {
        if (document.getElementById("rbr-add-popup-wrapper")) {
            this.addPopupWrapperRoot?.unmount();
        }
        this.closePopup();
    }

    addSubAiItem = (params: { items: any; }, e: any) => {
        const _this = this;
        const { t } = this.props;
        const type = "ai";
        const filteredItems = params.items;
        $(".wbmodalmodalClass .errormsg").hide();
        if (filteredItems.length == 0) {
            $(".wbmodalmodalClass .errormsg")
                .show()
                .html(t('Please select parent action item.'));
            return;
        }

        // do action here.
        if (type == "ai") {
            const { boardDetails } = _this.props.board;
            const { ai } = _this.state;
            const columnId = ai.columnId || ai.state;
            const params = { actId: ai.id, parentId: filteredItems[0] };
            showLoaderWidget($("#content"));
            $.post(`${wbConfig.baseUrl}/activity/UpdateParentId`, params, resp => {
                if (document.getElementById("rbr-add-popup-wrapper")) {
                    this.addPopupWrapperRoot?.unmount();
                }
                _this.subAIClosePopup();
                removeLoader();
                if ($("#filters-chk-subactions").is(":checked")) {
                    this.props.dispatch(SidePanelAction.closeSidePanel());
                }
                this.props.dispatch(SidePanelAction.boardAiparentUpdate(params.actId, params.parentId, columnId));
                if (this.state.selectedTab == 'subAi') {
                    let columnData: any = boardDetails.columns.find((col) => col.id == columnId);

                    let cardData: any = columnData.data.find((item: { id: any; }) => item.id == ai.id)
                    if (cardData.subCount.totalCount == "0") {
                        this.setState({
                            aiSubActions: null
                        })
                    }
                }
            });
        }
    }

    openAiDetailPopupMenu = (item: { objVal?: any; aiId?: any; }) => {
        const { aiId } = item;
        const obj = item.objVal;
        const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${aiId}`;
        if (urlVal && aiId && obj) {
            this.onCloseAiPane();
            return openFullPopUp(aiFullViewPopUp, urlVal, $(obj));
        }
    }

    openAiDetailPopup = (aiId: any, obj: any) => {
        if (aiId) {
            const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${aiId}`;
            setTimeout(() => openFullPopUp(aiFullViewPopUp, urlVal, $(obj)), 500);
        }
    }

    pingAi = (item: { aiId?: any; receiverName?: any; }) => {
        const { t } = this.props;
        const { aiId } = item;
        const { receiverName } = item;
        $(".wsBoardWrapper .wspopupmenu-wrapper").hide();
        $.post(`${wbConfig.baseUrl}/activity/PingAI`, { actId: aiId }, () => {
            infoPopup.call(
                t('{{receiverName}} will get a notification and an email asking for an update', { receiverName })
            );
        });
    }

    hideShowListPopup = () => {
        setTimeout(() => this.setState({ showListPopup: "" }), 10);
    }

    removeSubAi = (id: any) => {
        const subAi = this.state.aiSubActions;
        if (subAi && subAi.length > 0) {
            const aiSubActions = subAi.filter((item: { id: any; }) => item.id != id);
            this.setState({ aiSubActions });
        }
    }

    subAiConvClick = (item: { id?: any; actionDet?: any; stateText?: string; parent: string; }) => {
        console.log('test', item)
        const parentId: any = null;
        const oldParentId: any = (item.actionDet && item.actionDet.parent) || item.parent;
        const stateVal: any = (item.actionDet && item.actionDet.stateText) || item.stateText == "Done" ? 1 : 0;
        const params = { actId: item.id, parentId };
        const { ai } = this.state;
        const columnId = ai.columnId || ai.state;
        showLoaderWidget($("#content"));
        $.post(`${wbConfig.baseUrl}/activity/UpdateParentId`, params, resp => {
            removeLoader();
            this.props.dispatch(SidePanelAction.boardSubToAIparentUpdate(params.actId, oldParentId, columnId, stateVal));
            this.setState({
                aiSubActions: this.state.aiSubActions && this.state.aiSubActions.filter((sub: { id: string }) => sub.id != item.id)
            })
        });
    }

    onCloseAiPane() {
        this.props.dispatch(SidePanelAction.closeSidePanel());
    }

    render() {
        const { board, t } = this.props;
        const { boardDetails } = board;
        const { ai } = this.state;
        const columnId = ai.columnId || ai.state;
        const ownerAccess: boolean = ai.full_access;
        const dueAccess =
            ai.full_access || ai.attr_access || ai.direct_parent_access;
        const startAccess =
            ai.full_access || ai.attr_access || ai.direct_parent_access;
        const ragAccess =
            ai.full_access || ai.attr_access || ai.direct_parent_access;
        const prioAccess =
            ai.full_access || ai.attr_access || ai.direct_parent_access;
        const stateAccess =
            ai.full_access || ai.attr_access || ai.direct_parent_access;
        const descAccess = ai.full_access;
        const effAccess = ai.full_access;
        const subAiAccess = ai.full_access;
        const tagAccess =
            ai.full_access || ai.attr_access || ai.direct_parent_access; // || this.props.isTeamAdmin;
        let aiSubTotalCount =
            ai.subCount && ai.subCount.totalCount ? ai.subCount.totalCount : 0;
        let aiSubDoneCount =
            ai.subCount && ai.subCount.doneCount ? ai.subCount.doneCount : 0;
        // if (Array.isArray(this.state.aiSubActions)) {
        //     aiSubTotalCount = this.state.aiSubActions.length;
        //     aiSubDoneCount = [this.state.aiSubActions.length].reduce(
        //         (prev, curr: any) => (curr.state == 0 ? prev++ : prev),
        //         0
        //     );
        // }
        const { showListPopup } = this.state;
        const relationshipsEnabled = getFeatureFlag('pmAIRelationshipsEnabled');
        const userDetails: any = boardDetails.user;
        const loggedInUserId = userDetails.id || 0;
        const activityTypeName = getActivityTypeName(ai.type);
        const menu: any = {};
        menu.items = [
            {
                menuId: 'full_details',
                title: t('Full Details'),
                handler: this.openAiDetailPopupMenu,
                item: { aiId: ai.id, objVal: "openAiDet" },
            }
        ];

        if (Number(ai.type) == ActivityIssueTypes.ActionItem) {
            if (ai.parent == null && ai.full_access) {
                menu.items.push({
                    menuId: 'convert_sub_ai',
                    title: t('Convert to subtask'),
                    handler: this.subAiClick,
                    item: {
                        id: this.state.ai.id,
                        type: this.props.type,
                        actionDet: this.state.ai
                    }
                });
            }
            if (ai.parent && ai.full_access) {
                menu.items.push({
                    menuId: 'convert_ai',
                    title: t('Convert to {{activityTypeName}}', { activityTypeName: activityTypeName.toLowerCase() }),
                    handler: this.subAiConvClick,
                    item: {
                        id: this.state.ai.id,
                        type: this.props.type,
                        actionDet: this.state.ai
                    }
                });
            }
        }
        if (
            loggedInUserId &&
            loggedInUserId != ai.owner
        ) {
            menu.items.push({
                menuId: 'ping',
                title: t('Ping'),
                handler: this.pingAi,
                item: { aiId: ai.id, receiverName: ai.owner_firstname }
            });
        }
        if (ai.full_access) {
            menu.items.push({
                menuId: 'delete',
                title: t('Delete'),
                handler: () => this.deleteAiClick(this.state.ai),
                item: { id: ai.id }
            });
        }

        menu.items.push({
            menuId: `copy_link`,
            title: t('Copy Link'),
            handler: this.copyAiLink,
            item: { aiId: ai.id },
            iconSrc: '/images/icons/doc/link_icon_png.png',
            iconAlt: t('Copy {{activityTypeName}} URL', { activityTypeName }),
        });

        const statePermMap = {
            state: stateAccess,
            priority: prioAccess,
            effort: effAccess,
            rag: ragAccess
        };

        return (
            <ThemeProvider>
                <div id={`wsBoardAiDet-${ai.id}`} className="sidePanel wsBoardAiDetWrapper displayCell">
                    <div className="wsBoardAiDetDiv customeBoardView" data-value={ai.id}>
                        <div className="sideHeaderSection">
                            <div className="wsBoardAiDescDiv pL10">
                                {!this.state.showAiDescEdit && (
                                    <div
                                        className="childWsBoardAiDescDiv displayInlineB clickable"
                                        data-perm-value={descAccess}
                                        onClick={e => this.showAiDescEditFn(e, true, descAccess)}
                                    >
                                        <div
                                            dangerouslySetInnerHTML={WbMarkdownHtml(
                                                WbEventHandlerMixins.nl2br(ai.description)
                                            )}
                                        />
                                    </div>
                                )}
                                {this.state.showAiDescEdit && (
                                    <div className="childWsBoardAiTextDesc displayInlineB ">
                                        <textarea
                                            autoFocus
                                            id="wsBoardAiDescEdit"
                                            data-id={ai.id}
                                            className="wsBoardAiDescEdit"
                                            ref="wsBoardAiDescEditRef"
                                            onBlur={e => this.showAiDescEditFn(e, false, descAccess)}
                                            onKeyPress={() =>
                                                WbEventHandlerMixins.descAutoHeight($("#wsBoardAiDescEdit"))
                                            }
                                            defaultValue={ai.description}
                                        />
                                    </div>
                                )}
                                <div
                                    data-testid="popUpIcon"
                                    className={`wsBoardAiFullDetIcon displayInlineB ${ai.id ? 'clickable' : ''} popUpIcon`}
                                    onClick={() => {
                                        this.openAiDetailPopup(ai.id, "wsBoardAiFullDetIcon");
                                        this.onCloseAiPane();
                                    }}
                                >
                                    {ai.id && <ImgIconComp id="full_det_img" width="14" height="14" />}
                                </div>
                                <div
                                    className="wsBoardAiFullDetIcon displayInlineB clickable closeIcon"
                                    onClick={() => this.onCloseAiPane()}
                                >
                                    <i className="icon icon-outline-close-24px"></i>
                                </div>
                            </div>
                            <div className="wsBoardAiOwnerWrapper pL10">
                                <div className="wsBoardAiOwnerImg displayInlineB vAlignMiddle">
                                    <ImgIconComp
                                        class="roundFramePhoto fitProfileImage"
                                        srcUrl={ai.ownerImage}
                                        width="30"
                                        height="30"
                                    />
                                </div>
                                <div className="displayInlineB pL10 wsBoardOwnerDiv wsBoardAiAttr">
                                    <div
                                        className="wsBoardAiOwnerName clickable"
                                        data-perm-value={ownerAccess}
                                        onClick={() => this.onShowListPopup("owner", ownerAccess)}
                                        title={`${ai.owner_firstname} ${ai.owner_lastname}`}
                                    >
                                        {`${ai.owner_firstname} ${ai.owner_lastname}`}
                                    </div>
                                    <div className="wsBoardOwnerListWrapper wsBoardAiAttrListDiv wsBoardAiAttr">
                                        {showListPopup == "owner" ? (
                                            <OwnerListComp
                                                hideShowListPopup={this.hideShowListPopup}
                                                aiId={ai.id}
                                                columnId={columnId}
                                                teamId={boardDetails.teamId}
                                                tagId={boardDetails.tagId}
                                                srcVal="act"
                                                dispatch={this.props.dispatch}
                                                updateLoop={this.updateLoop}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                                <div
                                    className="wsBoardAiAttr clickable"
                                    data-perm-value={startAccess}
                                    onClick={() => this.startDateClick(ai.id)}
                                >
                                    <span className="wsBoardAiStartLabel pL10">{t('Start')}</span>
                                    <span className="wsBoardAiStartText">
                                        {ai.startDateText}
                                        <input
                                            type="text"
                                            className="dueDateDiv"
                                            name="start_date"
                                            id="wsBoardAiStartText"
                                            defaultValue={ai.startDateText}
                                        />
                                    </span>
                                </div>
                                <div
                                    className="wsBoardAiAttr clickable"
                                    data-perm-value={dueAccess}
                                    onClick={() => this.dueDateClick(ai.id)}
                                >
                                    <span className="wsBoardAiDueLabel ">{t('End')}</span>
                                    <span className="wsBoardAiDueText">
                                        {ai.dueDateText}
                                        <input
                                            type="text"
                                            className="dueDateDiv"
                                            name="due_date"
                                            id="wsBoardAiDueText"
                                            defaultValue={ai.dueDateText}
                                        />
                                    </span>
                                </div>
                            </div>
                            {ai.parentAiName && (
                                <div
                                    className="wsBoardAiParentLink pL10"
                                    key={`${ai.id}_${ai.parent}`}
                                >
                                    <span>{t('Subaction of')}</span>
                                    <span
                                        className="wsBoardparentAiName clickable"
                                        onClick={() =>
                                            this.openAiDetailPopup(ai.parent, "wsBoardparentAiName")
                                        }
                                    >
                                        {ai.parentAiName}
                                    </span>
                                </div>
                            )}
                            <div className="wsBoardAiAttrWrapper pL10" ref={this.showListRef} style={{ display: 'flex', gap: '7px' }}>
                                {

                                    ["state", "priority", "effort", "rag"].map((v, index) => (
                                        <InLineStateList
                                            key={`${v}-${index}`}
                                            name={v}
                                            type={ai.type}
                                            value={ai[v]}
                                            isAttrAccess={statePermMap[v] ?? false}
                                            isShowListPopup={(showListPopup == v)}
                                            actId={ai.id}
                                            tagId={boardDetails.tagId}
                                            columnId={columnId}
                                            dispatchAction={this.props.dispatch}
                                            onShowListPopup={this.onShowListPopup}
                                            onHideListPopup={this.hideShowListPopup}
                                        />
                                    ))
                                }
                            </div>
                            <div className="wsBoardAiDivTabWrapper pL10">
                                <div
                                    title={t('Notes')}
                                    className={
                                        this.state.selectedTab == "notes"
                                            ? "wsBoardAiTabDiv wsBoardAiNotes clickable active"
                                            : "wsBoardAiTabDiv wsBoardAiNotes clickable"
                                    }
                                    onClick={() => this.tabClick("notes")}
                                />
                                <span
                                    className="wsBoardCountDetailsAi"
                                    data-testid="wsBoardCountDetailsAi"
                                >
                                    {ai.commentCount ? ai.commentCount : "0"}
                                </span>
                                <div
                                    className={
                                        this.state.selectedTab == "comments"
                                            ? "wsBoardAiTabDiv wsBoardAiComments clickable active"
                                            : "wsBoardAiTabDiv wsBoardAiComments clickable"
                                    }
                                    title={t('Comments')}
                                    data-testid="comments"
                                    onClick={() => this.tabClick("comments")}
                                />
                                {!ai.parent && (
                                    <div
                                        title={t('Subtasks')}
                                        className={
                                            this.state.selectedTab == "subAi"
                                                ? "wsBoardAiTabDiv wsBoardAiSubAi clickable active"
                                                : "wsBoardAiTabDiv wsBoardAiSubAi clickable"
                                        }
                                        onClick={() => this.tabClick("subAi")}
                                    >
                                        <span className="wsBoardCountDetailsAi">{`${aiSubDoneCount}/${aiSubTotalCount}`}</span>
                                    </div>
                                )}
                                <span title={t('Attachments')} className="wsBoardCountDetailsAi">
                                    {ai.attachCount ? ai.attachCount : "0"}
                                </span>
                                <div
                                    title={t('Attachments')}
                                    className={
                                        this.state.selectedTab == "attach"
                                            ? "wsBoardAiTabDiv wsBoardAiAttach clickable active"
                                            : "wsBoardAiTabDiv wsBoardAiAttach clickable"
                                    }
                                    onClick={() => this.tabClick("attach")}
                                />
                                <span title={t('In the Loop')} className="wsBoardCountDetailsAi">
                                    {ai.loopCount ? ai.loopCount : "0"}
                                </span>
                                <div
                                    title={t('In the Loop')}
                                    className={
                                        this.state.selectedTab == "loop"
                                            ? "wsBoardAiTabDiv wsBoardAiLoop clickable active"
                                            : "wsBoardAiTabDiv wsBoardAiLoop clickable"
                                    }
                                    onClick={() => this.tabClick("loop")}
                                />
                                <span title={t('Tags')} className="wsBoardCountDetailsAi">
                                    {ai.tagCount ? ai.tagCount : "0"}
                                </span>
                                <div
                                    title={t('Tags')}
                                    className={
                                        this.state.selectedTab == "tags"
                                            ? "wsBoardAiTabDiv wsBoardAiTag clickable active"
                                            : "wsBoardAiTabDiv wsBoardAiTag clickable"
                                    }
                                    onClick={() => this.tabClick("tags")}
                                />
                                {relationshipsEnabled
                                    ? <>
                                        <span title={t('Related')} className="wsBoardCountDetailsAi">
                                            {ai.relationshipsCount ? ai.relationshipsCount : "0"}
                                        </span>
                                        <div
                                            title={t('Related')}
                                            className={
                                                this.state.selectedTab == "relationships"
                                                    ? "wsBoardAiTabDiv wsBoardAiRelationships clickable active"
                                                    : "wsBoardAiTabDiv wsBoardAiRelationships clickable"
                                            }
                                            onClick={() => this.tabClick("relationships")}
                                        />
                                    </>
                                    : null
                                }
                                <div
                                    title={t('History')}
                                    className={
                                        this.state.selectedTab == "recentAct"
                                            ? "wsBoardAiTabDiv wsBoardAiRecentAct clickable active"
                                            : "wsBoardAiTabDiv wsBoardAiRecentAct clickable"
                                    }
                                    onClick={() => this.tabClick("recentAct")}
                                />
                                {menu && Object.keys(menu.items).length > 0 && (
                                    <div className="wsBoardAiKebebDiv clickable">
                                        {ai.id &&
                                            <TabHamburgMenu
                                                key={`${ai.id}_${ai.parent}`}
                                                menu={menu}
                                            />
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="wsBoardAiTabContentWrapper">
                            <div>
                                {this.state.selectedTab == "loop" ? (
                                    <AiLoopComp
                                        aiLoopMembers={this.state.aiLoopMembers}
                                        aiDet={ai}
                                        addLoopToStateList={this.addLoopToStateList}
                                        removeItemFromList={this.removeItemFromList}
                                        loopRemoveAccess
                                        v1Loop={false}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {this.state.selectedTab == "comments" ? (
                                    <AiCommentsComp
                                        aiComments={this.state.loadComments}
                                        aiId={ai.id}
                                        ownerAccess={ownerAccess}
                                        addComment={this.addComment}
                                        editComment={this.editComment}
                                        removeCommentFromList={this.removeCommentFromList}
                                        loggedInUserId={loggedInUserId}
                                        board={this.props.board.boardDetails}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {this.state.selectedTab == "subAi" ? (
                                    <AiSubActionsComp
                                        key={`aiSub-${ai.id}`}
                                        aiSubActions={this.state.aiSubActions}
                                        addAiSubAction={this.addAiSubAction}
                                        subAiAccess={subAiAccess}
                                        startAccess={startAccess}
                                        deleteAiClick={this.deleteAiClick}
                                        subAiConvClick={this.subAiConvClick}
                                        openAiDetailPopup={this.openAiDetailPopup}
                                        aiDet={ai}
                                        removeSubAi={this.removeSubAi}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {this.state.selectedTab == "attach" ? (
                                    <AiAttachmentsComp
                                        aiAttachments={this.state.aiAttachments}
                                        s3Data={this.state.s3Data}
                                        addAttachToStateList={this.addAttachToStateList}
                                        updateAttachState={this.updateAttachState}
                                        upload_max_size={this.state.upload_max_size}
                                        upload_max_size_configured={
                                            this.state.upload_max_size_configured
                                        }
                                        removeItemFromList={this.removeItemFromList}
                                        ownerAccess={ownerAccess}
                                        aiDet={ai}
                                        isNoAttachmentDownload={this.state.isNoAttachmentDownload}
                                        isFUSEnabled={boardDetails.isFUSEnabled}
                                        loggedInUserId={loggedInUserId}
                                        orgId={boardDetails.orgId}
                                        appinID={boardDetails.appinID}
                                        accessToken={boardDetails.accessToken}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {this.state.selectedTab == "tags" ? (
                                    <AiTagsComp
                                        aiTags={this.state.aiTags}
                                        aiDet={ai}
                                        addTagToStateList={this.addTagToStateList}
                                        removeItemFromList={this.removeItemFromList}
                                        tagAccess={tagAccess}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {this.state.selectedTab == "recentAct" ? (
                                    <AiRecentActivityComp aiRecentAct={this.state.aiRecentAct} />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {this.state.selectedTab == "notes" ? (
                                    <AiNotesComp
                                        notes={this.state.aiNote}
                                        updateAiNote={this.updateAiNote}
                                        aiId={ai.id}
                                        notesOrig={this.state.updatedAiNotes}
                                        saveAiNote={this.saveAiNote}
                                        descAccess={descAccess}
                                        editorConfiguration={editorConfiguration}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                            <div>
                                {relationshipsEnabled && this.state.selectedTab == "relationships"
                                    ? (
                                        <ThemeProvider>
                                            <ToastNotificationProvider>
                                                <GlobalConfigProvider>
                                                    <QueryProvider>
                                                        <Relationships
                                                            itemId={parseInt(ai.id)}
                                                            variant="condensed"
                                                            updateRelationshipCount={
                                                                (relationshipsCount) => {
                                                                    this.props.dispatch(
                                                                        updateRelationshipCounts({
                                                                            requestedIds: [ai.id],
                                                                            counts: [{ actionItemId: ai.id, relationshipsCount }]
                                                                        }
                                                                        ))
                                                                }
                                                            }
                                                        />
                                                    </QueryProvider>
                                                </GlobalConfigProvider>
                                            </ToastNotificationProvider>
                                        </ThemeProvider>
                                    )
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

export default withTranslation()(SidePanel);